angular.module('aprima-core-ui').directive('apDynamicFrame',
    [
        function () {
            'use strict';

            function link($scope) {
                function _resize(id){
                    var newHeight;

                    if(document.getElementById){
                        newHeight = document.getElementById(id).contentWindow.document.body.scrollHeight;
                        newHeight = newHeight + 30; //added to ensure no scroll bar
                    }
                    document.getElementById(id).height = (newHeight) + 'px';
                }
                function _reload(id){
                    var iframeDocument = document.getElementById(id).contentWindow.document;
                    var content = $scope.html;
                    iframeDocument.write(content);

                    _resize(id);
                }

                $scope.resize = _resize;
                $scope.reload = _reload;
            }

            return {
                restrict: 'EA',
                templateUrl: '/app/views/directives/apDynamicFrame.html',
                scope: {
                    html: '=html',
                    loadingUrl: '=loadingUrl'
                },
                link: link

            };
        }]);